import React from 'react';
import { useTranslation } from 'react-i18next';
import { RotatingLines } from 'react-loader-spinner';
import CommonLinearProgress from '../../../../../../components/common-linear-progress/CommonLinearProgress';
import Check from '@mui/icons-material/Check';
import Close from '@mui/icons-material/Close';

import { ICONS } from '../../../../../../icons';
import TooltipButton from '../../../../../../components/tooltip-button/TooltipButton';
import Icon from '../../../../../../icons/Icon';
import { BUTTON_STYLES } from '../../../../../../components/common-button/CommonButton';
import { MEDIA_UPLOAD_STATUS } from '../../../../../../constants';

import scss from './LoadingSection.module.scss';

function LoadingSection({ status, progress }) {
  const { t } = useTranslation('activ8');

  return (
    <div className={scss.section}>
      <div className={scss.title}>
        <span>{t('uploading')}</span>
        {status === MEDIA_UPLOAD_STATUS.UPLOADING ? (
          <RotatingLines strokeColor='#fdbf47' strokeWidth='3' animationDuration='0.75' width={18} visible={true} />
        ) : null}
        {status === MEDIA_UPLOAD_STATUS.SUCCEEDED ? <StatusIcon color='var(--color-success)' Icon={Check} /> : null}
        {status === MEDIA_UPLOAD_STATUS.FAILED ? <StatusIcon color='var(--color-failure)' Icon={Close} /> : null}
        {/* {status === MEDIA_UPLOAD_STATUS.FAILED ? (
          <TooltipButton
            tooltip={t('retry')}
            styleColor={BUTTON_STYLES.SECONDARY}
            isStrokeIcon
            maxWidth={32}
            className={scss.retryButton}>
            <Icon icon={ICONS.Reload} disableCommonColors />
          </TooltipButton>
        ) : null} */}
      </div>

      <CommonLinearProgress progress={progress} />
    </div>
  );
}

export default LoadingSection;

const StatusIcon = ({ color, Icon }) => {
  return (
    <div className={scss.statusIconWrapper} style={{ backgroundColor: color }}>
      <Icon />
    </div>
  );
};
